import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-chart-full-light-lines')
export class ObiChartFullLightLines extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.6955 2.64962L18.7332 3.78255C19.2205 4.71552 19.6224 5.68724 19.9358 6.68576L22.1244 6.09931L22.5126 7.5482L20.324 8.13465C20.606 9.3984 20.75 10.6944 20.75 12.0001C20.75 13.3058 20.606 14.6019 20.324 15.8656L22.5126 16.4521L22.1244 17.901L19.9357 17.3145C19.6224 18.313 19.2205 19.2847 18.7332 20.2177L20.6955 21.3506L19.9455 22.6496L1.5 12.0001L19.9455 1.35059L20.6955 2.64962ZM15.2651 5.78486L17.4329 4.53328C17.8561 5.35129 18.2078 6.20151 18.4855 7.07436L16.0676 7.72223C15.8504 7.05859 15.5823 6.41083 15.2651 5.78486ZM8.30847 9.80128L13.9639 6.53612C14.2183 7.04648 14.4361 7.57281 14.6163 8.11111L8.30847 9.80128ZM8.3087 14.1991L13.9639 17.4641C14.2183 16.9538 14.4361 16.4274 14.6163 15.8892L8.3087 14.1991ZM15.2651 18.2154L17.4329 19.4669C17.8561 18.6489 18.2078 17.7987 18.4854 16.9259L16.0676 16.278C15.8503 16.9417 15.5823 17.5894 15.2651 18.2154ZM15.0045 9.56L5.89778 12.0001L15.0045 14.4403C15.1671 13.6404 15.25 12.823 15.25 12.0001C15.25 11.1772 15.1671 10.3599 15.0045 9.56Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.6955 2.64962L18.7332 3.78255C19.2205 4.71552 19.6224 5.68724 19.9358 6.68576L22.1244 6.09931L22.5126 7.5482L20.324 8.13465C20.606 9.3984 20.75 10.6944 20.75 12.0001C20.75 13.3058 20.606 14.6019 20.324 15.8656L22.5126 16.4521L22.1244 17.901L19.9357 17.3145C19.6224 18.313 19.2205 19.2847 18.7332 20.2177L20.6955 21.3506L19.9455 22.6496L1.5 12.0001L19.9455 1.35059L20.6955 2.64962ZM15.2651 5.78486L17.4329 4.53328C17.8561 5.35129 18.2078 6.20151 18.4855 7.07436L16.0676 7.72223C15.8504 7.05859 15.5823 6.41083 15.2651 5.78486ZM8.30847 9.80128L13.9639 6.53612C14.2183 7.04648 14.4361 7.57281 14.6163 8.11111L8.30847 9.80128ZM8.3087 14.1991L13.9639 17.4641C14.2183 16.9538 14.4361 16.4274 14.6163 15.8892L8.3087 14.1991ZM15.2651 18.2154L17.4329 19.4669C17.8561 18.6489 18.2078 17.7987 18.4854 16.9259L16.0676 16.278C15.8503 16.9417 15.5823 17.5894 15.2651 18.2154ZM15.0045 9.56L5.89778 12.0001L15.0045 14.4403C15.1671 13.6404 15.25 12.823 15.25 12.0001C15.25 11.1772 15.1671 10.3599 15.0045 9.56Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-chart-full-light-lines': ObiChartFullLightLines;
  }
}
